import { State, tenancyScheduleWidgetColumnAdapter, TenancyScheduleColumnInstance } from
  "../reducers/tenancy-schedule-table-columns";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectTenancyScheduleColumnState = createFeatureSelector<State>('tenancyScheduleAvailableColumns');

export const {
  selectIds,
  selectEntities,
  selectTotal,
} = tenancyScheduleWidgetColumnAdapter.getSelectors(selectTenancyScheduleColumnState);


export const selectEntityByWidgetId = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);

export function getAvailableColumns(widgetId: string) {
  return createSelector(
    [selectEntityByWidgetId(widgetId)],
    (tenancyScheduleColumnInstance: TenancyScheduleColumnInstance) => {
        return tenancyScheduleColumnInstance.availableColumns;
    }
  );
}
